import { useCallback, useEffect, useState } from "react";
import { GetProductOrderByOrderId } from "../../_services";
import { useParams } from "react-router-dom";
import CustomerOrderDetail from "../customers/CustomerDetail/CustomerOrderDetail";
import Layout from "../shared/Layout";

const OrderDetail = () => {
    const [productOrderDetails, setProductOrderDetails] = useState([]);
    const params = useParams();
    const orderId = params?.id;

    const onCustomerOrderDetail = useCallback(async (item) => {
        try {
            const productOrderDetails = await GetProductOrderByOrderId(orderId);

            setProductOrderDetails(productOrderDetails.data[0]);
        } catch (error) {
            setProductOrderDetails([]);
        }
    }, [orderId]);

    useEffect(() => {
        onCustomerOrderDetail();
    }, [onCustomerOrderDetail]);

    return (
        <Layout>
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Order Details</h4>
                    </div>
                </div>
                <CustomerOrderDetail
                    order_id={productOrderDetails.order_id}
                    order_date={productOrderDetails.order_date}
                    order_items={productOrderDetails.order_items}
                    sub_total={productOrderDetails?.sub_total}
                    billing_customer_name={productOrderDetails?.billing_customer_name}
                    billing_phone={productOrderDetails?.billing_phone}
                    billing_city={productOrderDetails?.billing_city}
                    billing_pincode={productOrderDetails?.billing_pincode}
                    billing_address={productOrderDetails?.billing_address}
                    billing_address_2={productOrderDetails?.billing_address_2}
                    billing_state={productOrderDetails?.billing_state}
                    billing_country={productOrderDetails?.billing_country}
                />
            </div>
        </Layout>
    )
}

export default OrderDetail;